/* eslint-disable import/prefer-default-export */
import { Link } from 'react-router-dom';
import {
  ComboBox,
  Button,
  FormLabel,
  DropdownSkeleton,
  Loading,
  TextArea,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
} from 'carbon-components-react';
import { Online, Offline } from './OnLineOffLine';
import React from 'react';

export const WFActionModal = (props) => {
  const isConfirmButtonDisabled = () => {
    return (
      (props.approver == null && props.withApprover) ||
      (props.withTimeApproval && props.month == null && props.trimester == null) ||
      (props.withTimeApproval && props.year == null)
    );
  };
  const Role = props.approverRole == 'Division Manager' ? 'Consolidator' : props.approverRole;
  const year = new Date().getFullYear();

  //RITM0574609
  const years = Array.from(new Array(5), (val, index) => (index + (year-2)).toString());
  
  const months = [
    { name: 'Jan', id: 1 },
    { name: 'Feb', id: 2 },
    { name: 'Mar', id: 3 },
    { name: 'Apr', id: 4 },
    { name: 'May', id: 5 },
    { name: 'Jun', id: 6 },
    { name: 'Jul', id: 7 },
    { name: 'Aug', id: 8 },
    { name: 'Sep', id: 9 },
    { name: 'Oct', id: 10 },
    { name: 'Nov', id: 11 },
    { name: 'Dec', id: 12 },
  ];
  const trimesters = [
    { name: 'Jan - Feb - Mar', id: 1 },
    { name: 'Apr - May - Jun', id: 2 },
    { name: 'Jul - Aug - Sep', id: 3 },
    { name: 'Oct - Nov - Dec', id: 4 },
  ];

  //RITM0646764
  const withApproverAndWarning = (props.withApprover && (props.approverWarning !== null && props.approverWarning !== undefined && props.approverWarning !== '')) || false;
  
  return (
    <ComposedModal
      className="light-modal box-medium-modal"
      open={props.show}
      danger="false"
      onClose={() => {
        return false;
      }}
    >
      <ModalHeader
        className="margin-modal"
        title={props.title}
        iconDescription="Close"
        buttonOnClick={props.onCancel}
      ></ModalHeader>

      <ModalBody className="margin-modal modal-nooverflow confirm-modal">
        {withApproverAndWarning ? (
          <div>
            <p className="text-alert">{props.approverWarning}</p>
            <FormLabel className="some-class">{Role}</FormLabel>
            {props.isLoadingOptions ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="combo-approval"
                className="selection-items-list-costum"
                placeholder={'Select ' + Role}
                items={props.approverOptions}
                itemToString={(item) =>
                  item ? item.name + ' ' + item.surname + ' (' + item.email + ')' : ''
                }
                itemToElement={(item) =>
                  item ? `${item.name + ' ' + item.surname + ' (' + item.email + ')'} ` : ''
                }
                onChange={({ selectedItem }) => props.onApproverSelect(selectedItem)}
              />
            )}
          </div>
        ) : props.withApprover ? (
          <div>
            <FormLabel className="some-class">{Role}</FormLabel>
            {props.isLoadingOptions ? (
              <DropdownSkeleton />
            ) : (
              <ComboBox
                id="combo-approval"
                className="selection-items-list-costum"
                placeholder={'Select ' + Role}
                items={props.approverOptions}
                itemToString={(item) =>
                  item ? item.name + ' ' + item.surname + ' (' + item.email + ')' : ''
                }
                itemToElement={(item) =>
                  item ? `${item.name + ' ' + item.surname + ' (' + item.email + ')'} ` : ''
                }
                onChange={({ selectedItem }) => props.onApproverSelect(selectedItem)}
              />
            )}
          </div>
        ) : (
          <div>
            <p>Do you want to {props.action.toLowerCase()} selected entities?</p>
            {props.approvalNotesRequired ? (
              <TextArea
                maxLength={5000}
                id="approvalNotes"
                placeholder="Notes"
                value={props.approvalNotes}
                onChange={props.onApprovalNotesChange}
                hideLabel={true}
                labelText=""
                light
                rows={2}
                cols={100}
              />
            ) : null}
          </div>
        )}

        {props.withTimeApproval ? (
          <div>
            <FormLabel>Year</FormLabel>
            <ComboBox
              id="cb_year"
              placeholder="Year"
              items={years}
              onChange={props.onApprovalYearChange}
              itemToString={(item) => item || ''}
            />
            {props.approvalTimeIntervalType === 'trimester' ? (
              <>
                <FormLabel>Trimester</FormLabel>
                <ComboBox
                  id="cb_appTTT_T"
                  placeholder="Trimester"
                  items={trimesters}
                  onChange={props.onApprovalTrimesterChange}
                  itemToString={(item) => (item ? item.name : '')}
                  selectedItem={trimesters.find((t) => props.trimester === t.id) || null}
                />
              </>
            ) : (
              <>
                <FormLabel>Month</FormLabel>
                <ComboBox
                  id="cb_appTTT_M"
                  placeholder="Month"
                  items={months}
                  onChange={props.onApprovalMonthChange}
                  itemToString={(item) => (item ? item.name : '')}
                  selectedItem={months.find((m) => props.month === m.id) || null}
                />
              </>
            )}
          </div>
        ) : null}

        <div >
          <div className="bx--col">
            <ul>
              {props.validationMessages.map((e) => (
                <li className="srv-validation-message" key={e}>
                  {e}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button className="button--max-width" kind="secondary" onClick={props.onCancel}>
          Cancel
        </Button>
        <Online>
          <Button
            className="button--max-width"
            kind="primary"
            onClick={props.onConfirm}
            disabled={isConfirmButtonDisabled()}
          >
            Confirm
          </Button>
        </Online>
        <Offline>
          <Button className="button--max-width" kind="primary" onClick={props.onConfirm} disabled>
            Confirm
          </Button>
        </Offline>
      </ModalFooter>
      {!props.isLoadingOperation ? null : <Loading></Loading>}
    </ComposedModal>
  );
};
